module.exports = __webpack_public_path__ + "static/img/DayangRos_Logo.42beb1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/DayangRos_Logo.png
// module id = NSUv
// module chunks = 0